import axios from "axios";
import toast from "react-hot-toast";

let isSessionExpired = false;

const API_URL = process.env.REACT_APP_API_URL || 'https://wip.fibrebondindustries.com';
//const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:5050';
const API_BASE_PATH = process.env.REACT_APP_API_BASE_PATH || `${API_URL}/backend`;

const axiosInstance = axios.create({
  baseURL: API_URL,
  baseURLPath: API_BASE_PATH,
  withCredentials: true
});

// response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {

    if (error.response && error.response.status === 401 && !isSessionExpired) {

      isSessionExpired = true; // prevent multiple triggers

      try {
        // CALL LOGOUT API BEFORE CLEARING SESSION
        await axios.post(
          `${API_URL}/api/logout`,
          {},
          { withCredentials: true }
        );
      } catch (logoutError) {
        console.error("Logout API failed:", logoutError);
      }

      // cleanup local storage
      //localStorage.removeItem('deviceToken');
      localStorage.removeItem('user');
      localStorage.removeItem('loginTime');
      localStorage.removeItem('sessionExpiration');
      localStorage.removeItem('userData');
      window.dispatchEvent(new Event('wip-session-expired'));
      
      toast.error("Session expired. Please login again.");
      //window.location.href = "/";
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
